var initialState = {
    byId: {},
    allIds: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.payment) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.payment
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
}
